import { useState, useMemo } from "react";
import { AdminCategoriesManager } from "./admin-categories-manager";
import { AdminSubcategoriesManager } from "./admin-subcategories-manager";
import { AdminProductCategoriesManager } from "./admin-product-categories-manager";

export default function CategoryManager() {
  const [activeTab, setActiveTab] = useState<string>("categories");

  // Create persistent component instances using useMemo
  const persistentCategoriesManager = useMemo(() => {
    return <AdminCategoriesManager />;
  }, []);
  
  const persistentSubcategoriesManager = useMemo(() => {
    return <AdminSubcategoriesManager />;
  }, []);
  
  const persistentProductCategoriesManager = useMemo(() => {
    return <AdminProductCategoriesManager />;
  }, []);

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold">Category Management</h2>
        <p className="text-muted-foreground mt-2">
          Manage categories, subcategories, and product categories for the platform
        </p>
      </div>

      {/* Custom Tab Navigation */}
      <div className="w-full">
        <div className="border-b border-border">
          <nav className="-mb-px flex space-x-8">
            <button
              onClick={() => setActiveTab("categories")}
              className={`py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap ${
                activeTab === "categories"
                  ? "border-primary text-primary"
                  : "border-transparent text-muted-foreground hover:text-foreground hover:border-gray-300"
              }`}
            >
              Categories
            </button>
            <button
              onClick={() => setActiveTab("subcategories")}
              className={`py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap ${
                activeTab === "subcategories"
                  ? "border-primary text-primary"
                  : "border-transparent text-muted-foreground hover:text-foreground hover:border-gray-300"
              }`}
            >
              Subcategories
            </button>
            <button
              onClick={() => setActiveTab("product-categories")}
              className={`py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap ${
                activeTab === "product-categories"
                  ? "border-primary text-primary"
                  : "border-transparent text-muted-foreground hover:text-foreground hover:border-gray-300"
              }`}
            >
              Product Categories
            </button>
          </nav>
        </div>
        
        {/* Persistent Components - All are always rendered but only one is visible */}
        <div className="mt-6">
          <div style={{ display: activeTab === "categories" ? "block" : "none" }}>
            {persistentCategoriesManager}
          </div>
          <div style={{ display: activeTab === "subcategories" ? "block" : "none" }}>
            {persistentSubcategoriesManager}
          </div>
          <div style={{ display: activeTab === "product-categories" ? "block" : "none" }}>
            {persistentProductCategoriesManager}
          </div>
        </div>
      </div>
    </div>
  );
} 